<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar flat dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-sm-and-up" @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Neue Dienstleistung</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon :disabled="!serviceForm.valid" v-show="$vuetify.breakpoint.xs" @click.native="createService">
            <v-icon right>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="serviceForm.valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Name"
                  v-model="serviceForm.name"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-currency-field
                  label="Private Vergütung pro Stunde"
                  v-model="serviceForm.privateHourFee"
                  v-bind="currencyConfig"
                ></v-currency-field>
              </v-flex>
              <v-flex xs6>
                <v-currency-field
                  label="Gewerbliche Vergütung pro Stunde"
                  v-model="serviceForm.businessHourFee"
                  v-bind="currencyConfig"
                ></v-currency-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="hidden-xs-only">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Abbrechen</v-btn>
        <v-btn
          :disabled="!serviceForm.valid"
          :loading="loading"
          color="primary"
          text
          @click.native="createService">
          Dienstleistung anlegen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'NewServiceDialog',
    props: ['show'],
    data () {
      return {
        serviceForm: {
          valid: false,
          name: '',
          privateHourFee: 0.0,
          businessHourFee: 0.0
        },
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        currencyConfig: {
          decimal: ',',
          thousands: '.',
          prefix: '€ ',
          precision: 2
        }
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      }
    },
    methods: {
      createService () {
        this.$store.dispatch('addService', {
          name: this.serviceForm.name,
          privateHourFee: this.serviceForm.privateHourFee,
          businessHourFee: this.serviceForm.businessHourFee
        })
          .finally(() => this.close())
      },
      close () {
        this.clearForm()
        this.$emit('close')
      },
      clearForm () {
        this.serviceForm = initialState()
        this.$refs.form.reset()
      }
    }
  }

  function initialState () {
    return {
      valid: false,
      name: '',
      privateHourFee: 0.0,
      businessHourFee: 0.0
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Services/NewServiceDialog.vue